import { Component } from '@angular/core'

import { BaseComponent } from '../../shared'

interface SafetyChecklistDashboardKpi {
    totalReports: number
    reportsLast30Days: number
    equipmentLast30Days: number
    vehicleLast30Days: number
    injuryInvolvedCount: number
    dailyMeetingsLast30Days: number
    injuryReportsLast30Days: number
    confinedSpaceLast30Days: number
    openConfinedSpacePermits: number
}

interface FormTypeCount {
    formType: string
    count: number
}

interface MonthlyCount {
    label: string
    count: number
}

interface SafetyChecklistDashboardMetrics {
    kpi: SafetyChecklistDashboardKpi
    last30DaysByFormType: FormTypeCount[]
    monthlyCounts: MonthlyCount[]
}

const emptyMetrics = (): SafetyChecklistDashboardMetrics => ({
    kpi: {
        totalReports: 0,
        reportsLast30Days: 0,
        equipmentLast30Days: 0,
        vehicleLast30Days: 0,
        injuryInvolvedCount: 0,
        dailyMeetingsLast30Days: 0,
        injuryReportsLast30Days: 0,
        confinedSpaceLast30Days: 0,
        openConfinedSpacePermits: 0,
    },
    last30DaysByFormType: [
        { formType: 'Equipment Damage', count: 0 },
        { formType: 'Vehicle Damage', count: 0 },
        { formType: 'Corrective Action', count: 0 },
        { formType: 'Near Miss', count: 0 },
        { formType: 'Work Alone', count: 0 },
        { formType: 'Daily Meeting', count: 0 },
        { formType: 'Injury Report', count: 0 },
        { formType: 'Confined Space', count: 0 },
    ],
    monthlyCounts: [],
})

@Component({
    selector: 'app-safety-checklists-dashboard',
    templateUrl: './safety-checklists-dashboard.component.html',
    styleUrls: ['./safety-checklists-dashboard.component.css'],
    standalone: true,
})
export class SafetyChecklistsDashboardComponent extends BaseComponent {
    metrics: SafetyChecklistDashboardMetrics = emptyMetrics()
    metricsLoadError = false

    constructor() {
        super()
        this.refresh()
    }

    refresh() {
        this.cancelableRequest(
            'safetyChecklistDashboard',
            true,
            this.services.data.get<SafetyChecklistDashboardMetrics>('/api/SafetyChecklist/GetDashboardMetrics').subscribe({
                next: result => {
                    this.metrics = result ?? emptyMetrics()
                    if (!this.metrics.last30DaysByFormType?.length) {
                        this.metrics.last30DaysByFormType = emptyMetrics().last30DaysByFormType
                    }
                    this.metricsLoadError = false
                    this.initialLoadingComplete()
                },
                error: () => {
                    this.metrics = emptyMetrics()
                    this.metricsLoadError = true
                    this.initialLoadingComplete()
                },
            }),
        )
    }

    maxMonthlyCount(): number {
        return Math.max(...this.metrics.monthlyCounts.map(m => m.count), 1)
    }
}
